import type { DashboardWidgetConfiguration } from './widget-definition';

export const financeMoneyPositionWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.money-position",
  name: "Money and company position",
  description: "Posted Finance journal balances at a selected date, scoped by RQL permissions.",
  apps: [
    "finance",
  ],
  template: "finance-money",
  query: {
    kind: "component",
    owner: "finance-money",
  },
  inputs: {
    title: "Money and company position",
    mode: "full",
  },
  dummyData: {
    value: "Posted balances",
    rows: [],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 4,
    maxHeight: 12,
    defaultWidth: 12,
    defaultHeight: 8,
  },
};
